import React from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { SelectOption, SelectValue, SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";

import { Trans } from "app/utils";
import TextProperty from "../TextProperty";
import { BuiltInFontDefinition } from "../../../fonts/BuiltInFonts";

interface FontFamilyProps {
  activeElement: ElementState;
  defaultValue?: string;
  disabled?: boolean;
  onFontChange: (value: BuiltInFontDefinition) => void;
  onSubtitleChange?: (propertyName: string, value: string) => Promise<void>;
  parsedFonts: BuiltInFontDefinition[];
  preview: Preview;
}

const FontFamily: React.FC<FontFamilyProps> = ({
  activeElement,
  defaultValue,
  disabled,
  onFontChange,
  onSubtitleChange,
  parsedFonts,
  preview
}) => {
  const handleFontChange = (value: null | SelectValue | SelectValueWithCategory) => {
    const newFontValue = parsedFonts.find(parsedFont => parsedFont.family === value);
    if (newFontValue) onFontChange(newFontValue);
  };

  return (
    <div className="FontOptions--Font">
      <TextProperty
        activeElement={activeElement}
        defaultValue={defaultValue || "Aileron"}
        disabled={disabled}
        name="font"
        onChange={handleFontChange}
        options={parsedFonts as SelectOption[]}
        onSubtitleChange={onSubtitleChange}
        preview={preview}
        propertyName="font_family"
      >
        <Trans>Font</Trans>
      </TextProperty>
    </div>
  );
};

export default FontFamily;
